import { useDialog } from 'primevue/usedialog'
import FileList from '../components/cms/admin/image/fileList.vue'

export const useChooseFile = () => {
  const dialog = useDialog()
  // chooseFileFLag jak true to po kliknięciu w plik zamyka dialog
  const chooseFile = (chooseFileFlag: boolean = true): Promise<string> => {
    return new Promise((resolve) => {
      dialog.open(FileList, {
        props: {
          header: 'Wybierz plik',
          style: {
            width: '80vw',
            height: '80vh'
          },
          modal: true
        },
        data: {
          choose: chooseFileFlag
        },
        onClose: (options) => {
          if (!options?.data) return resolve('')
          resolve(options.data.src ?? '')
        }
      })
    })
  }

  return { chooseFile }
}
